import React from "react";
import {observer} from "mobx-react-lite";
import {Routes, Route, Navigate} from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Login from "../pages/login";
import Complaints from "../pages/complaints";
import Remarks from "../pages/remarks";
import Suggestions from "../pages/suggestions";
import PageNotFound from "../pages/notFound";
import Forbidden from "../pages/forbidden";
import Users from "../pages/users";
import ProductsAndTags from "../pages/tags";
import Roles from "../pages/roles";
import {$permissions} from "../store/permissions/permissions";
import {$user} from "../store/user";
import Permissions from "../pages/permissions";
import Chat from "../pages/chat";
import Notifications from "../pages/notifications";
import NotificationsForm from "../pages/notificationsForm";
import Reviews from "../pages/reviews";
import ChatStats from "../pages/chatStats";
import Receipts from "../pages/receipts";
import Badges from "../pages/bundles";
import Coupons from "../pages/coupons";
import FastOrderLinks from "../pages/fastOrderLinks";
import Promo from "../pages/promo";
import { appRoutes } from "./appRoutes";

export { appRoutes };

const protectedRoutes = [
  {
    path: appRoutes.receipts.value,
    element: <Receipts/>,
  },
  {
    path: appRoutes.bundles.value,
    element: <Badges/>,
  },
  {
    path: appRoutes.dashboard.value,
    element: <Dashboard/>,
  },
  {
    path: appRoutes.remarks.value,
    element: <Remarks/>,
  },
  {
    path: appRoutes.complaints.value,
    element: <Complaints/>,
  },
  {
    path: appRoutes.suggestions.value,
    element: <Suggestions/>,
  },
  {
    path: appRoutes.notifications.value,
    element: <Notifications/>,
  },
  {
    path: appRoutes.notificationsForm.value,
    element: <NotificationsForm/>,
  },
  {
    path: appRoutes.chat.value,
    element: <Chat/>,
  },
  {
    path: appRoutes.chatStats.value,
    element: <ChatStats/>,
  },
  {
    path: appRoutes.users.value,
    element: <Users/>,
  },
  {
    path: appRoutes.reviews.value,
    element: <Reviews/>,
  },
  {
    path: appRoutes.promo.value,
    element: <Promo/>,
  },
  {
    path: appRoutes.tags.value,
    element: <ProductsAndTags/>,
  },
  {
    path: appRoutes.roles.value,
    element: <Roles/>,
  },
  {
    path: appRoutes.coupons.value,
    element: <Coupons/>,
  },
  {
    path: appRoutes.fastOrderLinks.value,
    element: <FastOrderLinks/>,
  },
  {
    path: appRoutes.permissions.value,
    element: <Permissions/>,
  },
];

const AppRoutes = observer(() => {
  const ProtectedRoute = ({element, path}) => {
    if (!$user.isAuthorized) {
      return <Navigate to="/login" replace/>;
    }

    if ($permissions.isAllowedForRole(path)) {
      return element;
    }

    return <Navigate to="/403" replace/>;
  };

  return (
    <Routes>
      <Route element={<Navigate to="/dashboard" replace/>} path="/"/>
      {protectedRoutes.map((route) => (
        <Route
          element={<ProtectedRoute element={route.element} path={route.path}/>}
          key={route.path}
          path={route.path}
        />
      ))}
      <Route element={<Login/>} path="login"/>
      <Route element={<Forbidden/>} path="403"/>
      <Route element={<PageNotFound/>} path="404"/>
      <Route element={<Navigate to="/404" replace/>} path="*"/>
    </Routes>
  );
});

export default AppRoutes;
